import React from 'react'
import { Link } from 'gatsby'

import style from './Resources.module.scss'

const Resource = ({
  resource,
  microcopy
}) => (
  <Link
    to={ resource.path }
    className={ style.link }
  >
    <strong>{ microcopy.text('reference.titles.data')}</strong>
    <span>{ resource.title }</span>
  </Link>
)

export default Resource
